import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTaxRelationCountries, submitTaxRelationSection } from '../actions/tax-relation';
import TaxRelationSection from '../components/tax-relations';
export default connect(state => ({
  taxCountries: state.taxRelations.fetch,
  submitTaxRelations: state.taxRelations.submit,
  error: state.taxRelations.submit.error
}), dispatch => bindActionCreators({
  getTaxRelationCountries,
  submitTaxRelationSection
}, dispatch))(TaxRelationSection);